import { render, staticRenderFns } from "./QuotationAttachmentsManager.vue?vue&type=template&id=e70bcc54&"
import script from "./QuotationAttachmentsManager.vue?vue&type=script&lang=js&"
export * from "./QuotationAttachmentsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports